/**
 * @file SecurityRoleClientAttributesTab.js
 * @description Step 3 of the security role wizard — client attribute group selection.
 */
import React from 'react';
import SecurityRoleAttributeGroup from '../SecurityRoleAttributeGroup';
import { getText } from '../../../i18n';

const SecurityRoleClientAttributesTab = ({
    categories,
    groupsByCategory,
    attributesByGroup,
    groupSelections,
    onLevelChange,
    disabledGroups,
    dependentGroupIds,
    readOnly,
}) => {
    if (!categories.length) {
        return (
            <div className="text-center text-muted py-5">
                {getText('msg_691fb352858a')}
            </div>
        );
    }

    return (
        <div className="m-auto col-xs-12 col-sm-12 col-md-10 col-lg-8 px-4 py-5">
            {categories.map(category => (
                <SecurityRoleAttributeGroup
                    key={category.id}
                    category={category}
                    groups={groupsByCategory[category.id] ?? []}
                    attributesByGroup={attributesByGroup}
                    groupSelections={groupSelections}
                    onLevelChange={onLevelChange}
                    disabledGroups={disabledGroups}
                    dependentGroupIds={dependentGroupIds}
                    readOnly={readOnly}
                />
            ))}
        </div>
    );
};

export default SecurityRoleClientAttributesTab;
